<template>
  <div class="flex flex-col h-full w-[550px] gap-5 mx-10 mt-5">
    <InputText v-model="reminderTitle"></InputText>
    <Textarea v-model="reminderText" class="resize-none" rows="8"></Textarea>
    <SubmitButton :show-icon="false" label="Save" @click="submitReminder"></SubmitButton>
  </div>
</template>

<script setup lang="ts">
import { ReminderSchema, type Reminder } from "@/types/Reminder";

interface Props {
  reminders: Reminder[];
  editingReminder?: Reminder;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  edited: [editedReminder: Reminder];
  added: [newReminder: Reminder];
}>();

const reminderTitle = ref("");
const reminderText = ref("");

const submitReminder = (): void => {
  if (reminderTitle.value.length === 0) error("Invalid Reminder", "Title may not be empty");

  const reminder: Reminder = {
    reminderId: props.editingReminder != null ? props.editingReminder.reminderId : "",
    reminderTitle: reminderTitle.value,
    reminderText: reminderText.value == null ? "" : reminderText.value,
  };

  if (props.editingReminder == null) {
    axios
      .post("/reminder/add", reminder)
      .then((response) => {
        handleApiResponse(
          response,
          (result) => emit("added", ReminderSchema.parse(result)),
          (errors: ApiError[]) => error("Error Occurred", errors[0].message)
        );
      })
      .catch((e) => errorApi(e));
  } else {
    axios
      .post("/reminder/update", reminder)
      .then((response) => {
        handleApiResponse(
          response,
          () => emit("edited", reminder),
          (errors: ApiError[]) => error("Error Occurred", errors[0].message)
        );
      })
      .catch((e) => errorApi(e));
  }
};

onBeforeMount(async (): Promise<void> => {
  if (props.editingReminder == null) return;

  reminderTitle.value = props.editingReminder.reminderTitle;
  reminderText.value = props.editingReminder.reminderText;
});
</script>
